module.exports = __webpack_public_path__ + "static/media/sound-black-shadow-on.51a24f4e.png";